module.exports = __webpack_public_path__ + "img/Home_Bild2.f9b9147e.jpg";